const url = "/api/v1/profile_pictures";

export interface ProfilePictureCreateParams {
  profilePicture?: File;
}

export const profilePictureCreateQuery = (
  params: ProfilePictureCreateParams,
) => {
  if (!params.profilePicture) {
    throw new Error("No profile picture provided");
  }

  const data = new FormData();
  data.append("image", params.profilePicture);
  data.append("name", params.profilePicture.name);
  data.append("type", params.profilePicture.type);
  data.append("size", params.profilePicture.size.toString());

  return {
    body: data,
    method: "POST",
    url,
  };
};

export const profilePictureDestroyQuery = () => ({
  method: "DELETE",
  url,
});
